// Response statuses
export const ERROR = 'error', SUCCESS = 'success', SUCCESS_CAP = 'SUCCESS';

// Grant access error messages
export const MISSING_CONNECTION = 'Missing grant connection',
    GRANT_NOT_ALLOWED = 'Grant user not allowed',
    INSUFFICIENT_RIGHTS = 'Rights not sufficient';